import { useQuery } from "@tanstack/react-query";
import axios from "../axios";

const useGetCharities = () => {
  return useQuery({
    queryKey: ["charities"],
    queryFn: async () => {
      const response = await axios.get("/api/charity");
      return response.data;
    },
    staleTime: 30000, // Optional
  });
};

export default useGetCharities;
